<template>
  <el-row>
    <el-row>
      <div style="display: flex">
        <div style="margin: -12px 0 0 0; font-size: 18px">
          <el-button type="text" @click="inputType = 1">方式1</el-button>
        </div>
        <el-divider direction="vertical" style="margin-top: 8px"></el-divider>
        <div style="margin: -12px 0 0 0; font-size: 18px">
          <el-button type="text" @click="inputType = 2">方式2</el-button>
        </div>
      </div>
    </el-row>
    <el-row v-if="inputType == 1">
      <el-row :span="20">
        <el-row>
          <div class="titleStyle">样品信息</div>
          <el-col :span="20" :offset="1">
            <InputOriginSampleInfo
              ref="InputOriginSampleInfoRef"
            ></InputOriginSampleInfo>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <div class="titleStyle">原始样品分析与鉴定</div>
          <el-col :span="20" :offset="1">
            <InputOriginMethods
              ref="InputOriginMethodsRef"
            ></InputOriginMethods>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <div class="titleStyle">分离参数</div>
          <el-col :span="20" :offset="1">
            <InputMethodInfo ref="InputMethodInfoRef"></InputMethodInfo>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <div class="titleStyle">纯度及结果认定</div>
          <el-col :span="20" :offset="1">
            <InputResCondition ref="InputResConditionRef"></InputResCondition>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="c_padding_bottom">
          <div class="titleStyle">综合评价</div>
          <el-col :span="20" :offset="1">
            <InputComprehensiveEvaluation
              ref="InPutCompreEvalutionRef"
            ></InputComprehensiveEvaluation>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <div class="titleStyle">仪器信息</div>
          <InputMachineInfo ref="InputMachineInfoRef"></InputMachineInfo>
        </el-row>
      </el-row>
      <el-row class="text-center">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button type="primary" size="small" @click="saveSepaMethods"
          >保存</el-button
        >
      </el-row>
    </el-row>
    <el-row v-if="inputType == 2">
      <el-row>
        <el-steps class="c_margin_top" :active="stepActive">
          <el-step title="样品信息"></el-step>
          <el-step title="原始样品分析与鉴定"></el-step>
          <!-- <el-step title="样品预处理"></el-step> -->
          <el-step title="分离参数"></el-step>
          <el-step title="纯度及结果认定"></el-step>
          <el-step title="综合评价"></el-step>
          <el-step title="仪器信息"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </el-row>
      <el-row class="c_margin_top">
        <el-row v-if="stepActive == 0" class="c_min-height">
          <el-row class="c_margin_top">
            <el-col :span="20" :offset="1">
              <InputOriginSampleInfo
                ref="InputOriginSampleInfoRef"
              ></InputOriginSampleInfo>
            </el-col>
          </el-row>

          <el-row class="c_margin_top" style="text-align: center">
            <el-button type="primary" @click="clickNextSampleInfo" size="mini"
              >下一步</el-button
            >
          </el-row>
        </el-row>
        <el-row v-if="stepActive == 1" class="c_min-height">
          <el-row class="c_min-height">
            <el-col :span="20" :offset="1">
              <InputOriginMethods
                ref="InputOriginMethodsRef"
              ></InputOriginMethods>
            </el-col>
          </el-row>
          <el-row class="c_margin_top" style="text-align: center">
            <el-button type="primary" @click="stepActive -= 1" size="mini"
              >上一步</el-button
            >

            <el-button type="primary" @click="clickNextSolvent" size="mini"
              >下一步</el-button
            >
          </el-row>
        </el-row>
        <!-- <el-row v-if="stepActive == 2">
                    <el-row class="c_min-height">
                        <el-col :span="20" :offset="1">
                            <InputSamplePre ref="InputSamplePreRef"></InputSamplePre>
                        </el-col>
                    </el-row>
                    <el-row class="c_margin_top" style="text-align: center">
                        <el-button type="primary" @click="stepActive -=1" size="mini">上一步</el-button>
                        <el-button type="primary" @click="clickNextSampleWeight" size="mini">下一步</el-button>
                    </el-row>
                </el-row> -->
        <el-row v-if="stepActive == 2">
          <el-row class="c_min-height">
            <el-col :span="20" :offset="1">
              <InputMethodInfo ref="InputMethodInfoRef"></InputMethodInfo>
            </el-col>
          </el-row>
          <el-row class="c_margin_top" style="text-align: center">
            <el-button type="primary" @click="stepActive -= 1" size="mini"
              >上一步</el-button
            >
            <el-button type="primary" @click="clickNextFlashColumn" size="mini"
              >下一步</el-button
            >
          </el-row>
        </el-row>
        <el-row v-if="stepActive == 3">
          <el-row class="c_min-height">
            <el-col :span="20" :offset="1">
              <InputResCondition ref="InputResConditionRef"></InputResCondition>
            </el-col>
          </el-row>
          <el-row class="c_margin_top" style="text-align: center">
            <el-button type="primary" @click="stepActive -= 1" size="mini"
              >上一步</el-button
            >
            <el-button type="primary" @click="clickNextCondition" size="mini"
              >下一步</el-button
            >
          </el-row>
        </el-row>
        <el-row v-if="stepActive == 4">
          <el-row class="c_min-height">
            <el-col :span="20" :offset="1">
              <InputComprehensiveEvaluation
                ref="InPutCompreEvalutionRef"
              ></InputComprehensiveEvaluation>
            </el-col>
          </el-row>
          <el-row class="c_margin_top" style="text-align: center">
            <el-button type="primary" @click="stepActive -= 1" size="mini"
              >上一步</el-button
            >

            <el-button type="primary" @click="stepActive += 1" size="mini"
              >下一步</el-button
            >
          </el-row>
        </el-row>
        <el-row v-if="stepActive == 5">
          <el-row class="c_min-height">
            <el-col :span="20" :offset="1">
              <InputMachineInfo ref="InputMachineInfoRef"></InputMachineInfo>
            </el-col>
          </el-row>
          <el-row class="c_margin_top" style="text-align: center">
            <el-button type="primary" @click="stepActive -= 1" size="mini"
              >上一步</el-button
            >
            <el-button
              type="primary"
              @click="
                stepActive += 1;
                constructInputForm();
              "
              size="mini"
              >下一步</el-button
            >
          </el-row>
        </el-row>
        <el-row v-if="stepActive == 6">
          <SearchMethodsDetail v-bind:sepaMethods="form"></SearchMethodsDetail>
          <el-row class="text-center">
            <el-button type="primary" @click="stepActive -= 1" size="mini"
              >上一步</el-button
            >
            <el-button type="primary" size="small" @click="saveSepaMethodsTwo"
              >保存</el-button
            >
          </el-row>
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
import InputOriginMethods from "./inputSepaMethodsComponents/InpuOriginMethods";
// import InputSamplePre from './inputSepaMethodsComponents/InputSamplePre'
import InputMethodInfo from "./inputSepaMethodsComponents/InputMethodInfo";
import InputResCondition from "./inputSepaMethodsComponents/InputResCondition";
import InputComprehensiveEvaluation from "./inputSepaMethodsComponents/InputComprehensiveEvaluation";
import InputMachineInfo from "./inputSepaMethodsComponents/InputMachineInfo";
// import InputAuthorInfo from './inputSepaMethodsComponents/InputAuthorInfo'
import InputOriginSampleInfo from "./inputSepaMethodsComponents/InputOriginSampleInfo";
import SearchMethodsDetail from "./search/SearchMethodsDetail";

export default {
  name: "InputSepaMethods",
  components: {
    InputOriginMethods,
    // InputSamplePre,
    InputMethodInfo,
    InputResCondition,
    InputComprehensiveEvaluation,
    InputMachineInfo,
    // InputAuthorInfo,
    InputOriginSampleInfo,
    SearchMethodsDetail,
  },
  data() {
    return {
      onLoading: false,
      inputType: 1,
      stepActive: 0,
      form: {
        /**
         * 基础信息
         * */
        baseInfo: {
          /**
           * 版本控制信息
           * */
          version: "",
          /**
           * 是否已验证
           * */
          validateState: 0,
        },
        remark: "", //备注
      },
    };
  },
  methods: {
    clickNextSampleInfo() {
      this.$refs.InputOriginSampleInfoRef.submitForm();
      if (this.$store.state.sepaMethods.SampleInfo.TargetPic == "") {
        this.$message.error("请上传目标化合物的结构式");
        return;
      } else {
        this.stepActive += 1;
      }
    },
    clickNextCondition() {
      this.stepActive += 1;
    },
    clickNextFlashColumn() {
      for (
        let i = 0;
        i < this.$store.state.sepaMethods.GradientList.length;
        i++
      ) {
        let channel1 = [];
        for (
          let j = 0;
          j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
          j++
        ) {
          channel1.push(
            this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
          );
        }
        if (
          channel1.indexOf(
            this.$store.state.sepaMethods.GradientList[i].channel_1
          ) == -1
        ) {
          this.$store.state.sepaMethods.GradientList[i].channel_1 = "";
        }
        if (this.$store.state.sepaMethods.GradientList[i].channel_2 != "") {
          let values = [];
          for (
            let j = 0;
            j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
            j++
          ) {
            values.push(
              this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
            );
          }
          if (
            values.indexOf(
              this.$store.state.sepaMethods.GradientList[i].channel_2
            ) == -1
          ) {
            this.$store.state.sepaMethods.GradientList[i].channel_2 = "";
          }
        }
        if (this.$store.state.sepaMethods.GradientList[i].channel_3 != "") {
          let values = [];
          for (
            let j = 0;
            j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
            j++
          ) {
            values.push(
              this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
            );
          }
          if (
            values.indexOf(
              this.$store.state.sepaMethods.GradientList[i].channel_3
            ) == -1
          ) {
            this.$store.state.sepaMethods.GradientList[i].channel_3 = "";
          }
        }
      }
      let element = [];
      let element2 = [];
      for (
        let index = 0;
        index < this.$store.state.sepaMethods.GradientList.length;
        index++
      ) {
        element.push(
          this.$store.state.sepaMethods.GradientList[index].channel_1
        );
        element2.push(
          this.$store.state.sepaMethods.GradientList[index].channel_2
        );
      }
      this.$refs.InputMethodInfoRef.submitForm();
      console.log("flashColumn", this.$store.state.sepaMethods);
      if (this.$store.state.sepaMethods.MethodInfo.flashColumn == "") {
        this.$message.error("请输入色谱柱信息");
        return;
      } else if (this.$store.state.showSolvent) {
        this.$message.error("请完善色谱柱型号详情");
        return;
      } else if (
        this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
        this.$store.state.sepaMethods.MethodInfo.wavelengthChA == ""
      ) {
        this.$message.error("请完善检测波长1信息");
        return;
      } else if (
        this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
        this.$store.state.sepaMethods.MethodInfo.wavelengthChB == ""
      ) {
        this.$message.error("请完善检测波长2信息");
        return;
      } else if (
        this.$store.state.sepaMethods.MethodInfo.detectSetting == "1" &&
        this.$store.state.sepaMethods.MethodInfo.atomizationTemperature == ""
      ) {
        this.$message.error("请完善雾化温度");
        return;
      } else if (
        (this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
          this.$store.state.sepaMethods.MethodInfo.wavelengthChA == "0") ||
        (this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
          this.$store.state.sepaMethods.MethodInfo.wavelengthChB == "0")
      ) {
        this.$message.error("请正确输入检测波长");
        return;
      } else if (
        this.$store.state.sepaMethods.MethodInfo.detectSetting == "1" &&
        this.$store.state.sepaMethods.MethodInfo.atomizationTemperature == "0"
      ) {
        this.$message.error("请正确输入雾化温度");
        return;
      } else if (this.$store.state.showEluent) {
        this.$message.error("请完善溶剂信息");
        return;
      } else if (this.$store.state.sepaMethods.MethodInfo.loadAmount == "") {
        this.$message.error("请输入上样量");
        return;
      } else if (this.$store.state.showGradient) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (element.includes("")) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (element2.includes("")) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (this.$store.state.sepaMethods.Chromatographic == "") {
        this.$message.error("请上传分离图谱");
        return;
      } else {
        this.stepActive += 1;
      }
    },
    clickNextSolvent() {
      this.$refs.InputOriginMethodsRef.submitForm();
      // this.$refs.InputOriginMethodsRef.submitRFList();
      if (!this.$store.state.originMethods) {
        this.$message.error("请正确输入原始样品分析与鉴定信息");
        return;
      } else if (
        !this.$store.state.rfListOne ||
        !this.$store.state.rfListTwo ||
        !this.$store.state.rfListThree
      ) {
        this.$message.error("请正确输入正相参数信息");
        return;
      } else {
        this.stepActive += 1;
      }
    },
    constructInputForm: function () {
      //基础信息(版本、是否验证)
      this.form.baseInfo = this.$store.state.sepaMethods.baseInfo;
      //3. 分析方法
      this.form.sampleAnalysis = this.$store.state.sepaMethods.sampleAnalysis;
      //RF 正相
      this.form.RFList = this.$store.state.sepaMethods.RFList;
      this.form.RTList = this.$store.state.sepaMethods.RTList;
      //3. 分析方法中的展开剂信息
      this.form.SolventList = this.$store.state.sepaMethods.SolventList;
      //作者信息
      this.form.author = this.$store.state.sepaMethods.author;
      this.form.EvaluateSet = this.$store.state.sepaMethods.EvaluateSet;
      this.form.MachineInfo = this.$store.state.sepaMethods.MachineInfo;
      this.form.FlowRateList = this.$store.state.sepaMethods.FlowRateList;
      this.form.GradientList = this.$store.state.sepaMethods.GradientList;
      this.form.MethodInfo = this.$store.state.sepaMethods.MethodInfo;
      this.form.Chromatographic = this.$store.state.sepaMethods.Chromatographic;
      this.form.SampleInfo = this.$store.state.sepaMethods.SampleInfo;
      this.form.startObjects = this.$store.state.sepaMethods.startObjects;
      this.form.purityResConfirmation =
        this.$store.state.sepaMethods.purityResConfirmation;
      this.form.SamplePrepare = this.$store.state.sepaMethods.SamplePrepare;
      this.form.id = this.$store.state.sepaMethods.id;
      // this.form.MethodInfo.method_type = this.form.sampleAnalysis.type
    },
    saveSepaMethodsTwo: function () {
      for (
        let i = 0;
        i < this.$store.state.sepaMethods.GradientList.length;
        i++
      ) {
        let channel1 = [];
        for (
          let j = 0;
          j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
          j++
        ) {
          channel1.push(
            this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
          );
        }
        if (
          channel1.indexOf(
            this.$store.state.sepaMethods.GradientList[i].channel_1
          ) == -1
        ) {
          this.$store.state.sepaMethods.GradientList[i].channel_1 = "";
        }
        if (this.$store.state.sepaMethods.GradientList[i].channel_2 != "") {
          let values = [];
          for (
            let j = 0;
            j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
            j++
          ) {
            values.push(
              this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
            );
          }
          if (
            values.indexOf(
              this.$store.state.sepaMethods.GradientList[i].channel_2
            ) == -1
          ) {
            this.$store.state.sepaMethods.GradientList[i].channel_2 = "";
          }
        }
        if (this.$store.state.sepaMethods.GradientList[i].channel_3 != "") {
          let values = [];
          for (
            let j = 0;
            j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
            j++
          ) {
            values.push(
              this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
            );
          }
          if (
            values.indexOf(
              this.$store.state.sepaMethods.GradientList[i].channel_3
            ) == -1
          ) {
            this.$store.state.sepaMethods.GradientList[i].channel_3 = "";
          }
        }
      }
      let element = [];
      let element2 = [];
      for (
        let index = 0;
        index < this.$store.state.sepaMethods.GradientList.length;
        index++
      ) {
        element.push(
          this.$store.state.sepaMethods.GradientList[index].channel_1
        );
        element2.push(
          this.$store.state.sepaMethods.GradientList[index].channel_2
        );
      }
      if (!this.$store.state.SampleInfo) {
        this.$message.error("请输入结构式名称");
        return;
      } else if (!this.$store.state.originMethods) {
        this.$message.error("请正确输入原始样品分析与鉴定信息");
        return;
      } else if (
        !this.$store.state.rfListOne ||
        !this.$store.state.rfListTwo ||
        !this.$store.state.rfListThree
      ) {
        this.$message.error("请正确输入正相参数信息");
        return;
      } else if (this.$store.state.sepaMethods.MethodInfo.flashColumn == "") {
        this.$message.error("请输入色谱柱信息");
        return;
      } else if (this.$store.state.showSolvent) {
        this.$message.error("请完善色谱柱型号详情");
        return;
      } else if (this.$store.state.showEluent) {
        this.$message.error("请完善溶剂信息");
        return;
      } else if (this.$store.state.showGradient) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (element.includes("")) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (element2.includes("")) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (!this.$store.state.resCondition) {
        this.$message.error("请正确输入纯度及结果认定信息");
        return;
      } else if (
        (this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
          this.$store.state.sepaMethods.MethodInfo.wavelengthChA == "0") ||
        (this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
          this.$store.state.sepaMethods.MethodInfo.wavelengthChB == "0")
      ) {
        this.$message.error("请正确输入检测波长");
        return;
      }
      this.constructInputForm();
      let form = this.form;
      let startobject = [];
      for (let i = 0; i < form.startObjects.length; i++) {
        startobject.push({
          sample_cas_info: form.startObjects[i].cas,
          sample_name: form.startObjects[i].name,
          sample_pic: form.startObjects[i].png,
          sample_type: 1,
          sample_smiles:
            form.startObjects[i].smile == undefined
              ? ""
              : form.startObjects[i].smile,
        });
      }
      let tlcLists = [];
      let phlcLists = [];
      let hplcLists = [
        { component_index: "", area: 0, percent: "", tFlag: "", rt_time: "" },
        { component_index: "", area: 0, percent: "", tFlag: "", rt_time: "" },
        { component_index: "", area: 0, percent: "", tFlag: "", rt_time: "" },
      ];
      if (form.sampleAnalysis.type == 0) {
        if (form.SolventList.length > 0) {
          if (form.SolventList[0].Solvent != "") {
            tlcLists.push({
              percent: form.SolventList[0].Percent,
              eluent_channel: 0,
              solvent: form.SolventList[0].Solvent,
              polarity: form.SolventList[0].Polarity,
              density: form.SolventList[0].Density,
              solvent_id: form.SolventList[0].id,
            });
            if (form.SolventList[1].Solvent != "") {
              tlcLists.push({
                percent: form.SolventList[1].Percent,
                eluent_channel: 1,
                solvent: form.SolventList[1].Solvent,
                polarity: form.SolventList[1].Polarity,
                density: form.SolventList[1].Density,
                solvent_id: form.SolventList[1].id,
              });
            }
          }
        }
      } else {
        if (form.sampleAnalysis.hplc.hplcflowA != undefined) {
          if (form.sampleAnalysis.hplc.hplcflowA.length > 0) {
            phlcLists.push({
              eluent_channel: 0,
              solvent: form.sampleAnalysis.hplc.hplcflowA[0].Solvent,
              polarity: form.sampleAnalysis.hplc.hplcflowA[0].Polarity,
              density: form.sampleAnalysis.hplc.hplcflowA[0].Density,
              solvent_id: form.sampleAnalysis.hplc.hplcflowA[0].id,
            });
          }
        }
        if (form.sampleAnalysis.hplc.hplcflowB != undefined) {
          if (form.sampleAnalysis.hplc.hplcflowB.length > 0) {
            phlcLists.push({
              eluent_channel: 1,
              solvent: form.sampleAnalysis.hplc.hplcflowB[0].Solvent,
              polarity: form.sampleAnalysis.hplc.hplcflowB[0].Polarity,
              density: form.sampleAnalysis.hplc.hplcflowB[0].Density,
              solvent_id: form.sampleAnalysis.hplc.hplcflowB[0].id,
            });
          }
        }

        if (
          form.RTList[0].Time != "" ||
          form.RTList[1].Time != "" ||
          form.RTList[2].Time != ""
        ) {
          hplcLists = [];
          for (let i = 0; i < form.RTList.length; i++) {
            hplcLists.push({
              component_index: form.RTList[i].ComponentIndex,
              area: 0,
              percent: form.RTList[i].Percent,
              tFlag: form.RTList[i].TFlag,
              rt_time: form.RTList[i].Time,
            });
          }
        }
      }
      let saSolvents = [];
      if (form.sampleAnalysis.type == 0) {
        if (form.SolventList.length > 0) {
          if (
            form.SolventList[0].Solvent != "" ||
            form.SolventList[1].Solvent != ""
          ) {
            saSolvents = form.SolventList;
          }
        }
      }
      let tlcRFLists = [];
      if (
        form.RFList[0].Value != "" ||
        form.RFList[1].Value != "" ||
        form.RFList[2].Value != ""
      ) {
        for (let i = 0; i < form.RFList.length; i++) {
          tlcRFLists.push({
            value: form.RFList[i].Value,
            rfflag: parseInt(form.RFList[i].RFFlag),
          });
        }
      }
      let solventinfos = {
        eluent_solvent_channel_A: {},
        eluent_solvent_channel_B: {},
        eluent_solvent_channel_C: {},
        eluent_solvent_channel_D: {},
      };
      for (let i = 0; i < form.MethodInfo.solvents.length; i++) {
        if (form.MethodInfo.solvents[i].channel == "A") {
          solventinfos.eluent_solvent_channel_A = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
        if (form.MethodInfo.solvents[i].channel == "B") {
          solventinfos.eluent_solvent_channel_B = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
        if (form.MethodInfo.solvents[i].channel == "C") {
          solventinfos.eluent_solvent_channel_C = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
        if (form.MethodInfo.solvents[i].channel == "D") {
          solventinfos.eluent_solvent_channel_D = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
      }
      let gradInfo = [];
      for (let i = 0; i < form.GradientList.length; i++) {
        gradInfo.push({
          begin_cv: form.GradientList[i].begin_cv,
          end_cv: Number(form.GradientList[i].end_cv).toFixed(1).toString(),
          flow_rate: form.GradientList[i].flow_rate,
          begin_time: form.GradientList[i].begin_time,
          end_time: Number(form.GradientList[i].end_time).toFixed(1).toString(),
          channel_1: form.GradientList[i].channel_1,
          channel_2: form.GradientList[i].channel_2,
          channel_3: form.GradientList[i].channel_3,
          percent_3: form.GradientList[i].percent_3,
          begin_percent_2: form.GradientList[i].begin_percent_2,
          end_percent_2: form.GradientList[i].end_percent_2,
        });
      }
      let hplcValue = {};
      let purList = [];
      if (form.purityResConfirmation.hplc.hplcflowA != undefined) {
        if (form.purityResConfirmation.hplc.hplcflowA.length > 0) {
          purList.push({
            eluent_channel: 0,
            solvent: form.purityResConfirmation.hplc.hplcflowA[0].Solvent,
            polarity: form.purityResConfirmation.hplc.hplcflowA[0].Polarity,
            density: form.purityResConfirmation.hplc.hplcflowA[0].Density,
            solvent_id: form.purityResConfirmation.hplc.hplcflowA[0].id,
          });
        }
      }
      if (form.purityResConfirmation.hplc.hplcflowB != undefined) {
        if (form.purityResConfirmation.hplc.hplcflowB.length > 0) {
          purList.push({
            eluent_channel: 1,
            solvent: form.purityResConfirmation.hplc.hplcflowB[0].Solvent,
            polarity: form.purityResConfirmation.hplc.hplcflowB[0].Polarity,
            density: form.purityResConfirmation.hplc.hplcflowB[0].Density,
            solvent_id: form.purityResConfirmation.hplc.hplcflowB[0].id,
          });
        }
      }
      if (form.purityResConfirmation.hplc.flashColumn != undefined) {
        hplcValue = {
          analysisColumn: {
            flowPhase: form.purityResConfirmation.hplc.flashColumn.flow_rate,
            analysisName:
              form.purityResConfirmation.hplc.flashColumn.analysis_column,
            particleSize:
              form.purityResConfirmation.hplc.flashColumn.particle_diameter,
            innerDiameter:
              form.purityResConfirmation.hplc.flashColumn.inner_diameter,
            length: form.purityResConfirmation.hplc.flashColumn.length,
          },
          hplcPic: form.purityResConfirmation.hplc.hplcPic,
          solvents: purList,
        };
      }
      let hplcSValue = {};
      if (form.sampleAnalysis.type == 1) {
        if (form.sampleAnalysis.hplc != undefined) {
          hplcSValue = {
            analysisColumn: {
              flowPhase: form.sampleAnalysis.hplc.flashColumn.flow_rate,
              analysisName:
                form.sampleAnalysis.hplc.flashColumn.analysis_column,
              particleSize:
                form.sampleAnalysis.hplc.flashColumn.particle_diameter,
              innerDiameter:
                form.sampleAnalysis.hplc.flashColumn.inner_diameter,
              length: form.sampleAnalysis.hplc.flashColumn.length,
            },
            hplcPic: form.sampleAnalysis.hplc.hplcPic,
            solvents: phlcLists,
          };
        }
      }

      let solventConsume = [];
      if (form.MethodInfo.otherInfo.solventsConsume.length > 0) {
        if (form.MethodInfo.otherInfo.solventsConsume[0].solvents != "") {
          for (
            let i = 0;
            i < form.MethodInfo.otherInfo.solventsConsume.length;
            i++
          ) {
            solventConsume.push({
              solvents: form.MethodInfo.otherInfo.solventsConsume[i].solvents,
              vol: form.MethodInfo.otherInfo.solventsConsume[i].vol,
            });
          }
        }
      }
      let pSolvents = [];
      if (form.purityResConfirmation.type == 0) {
        if (form.purityResConfirmation.tlc.solvents.length > 0) {
          if (
            form.purityResConfirmation.tlc.solvents[0].Solvent != "" ||
            form.purityResConfirmation.tlc.solvents[1].Solvent != ""
          ) {
            pSolvents = form.purityResConfirmation.tlc.solvents;
          }
        }
      }

      if (this.$store.state.sepaMethods.edit) {
        let data = {
          methodCreateUserInfo: {
            username: this.$store.state.userId,
            organization: this.$store.state.org,
            email: this.$store.state.email,
          },
          methodMainInfo: {
            sepa_method_type: form.MethodInfo.method_type,
            spectrum_pic: form.Chromatographic,
            method_time: form.MethodInfo.method_time,
          },
          methodSampleInfo: {
            target_sample_list: [
              {
                sample_cas_info: form.SampleInfo.CAS,
                sample_name: form.SampleInfo.TargetName,
                sample_smiles: form.SampleInfo.TargetSmiles,
                sample_pic: form.SampleInfo.TargetPic,
                sample_type: 1,
              },
            ],
            reactant_sample_list: startobject,
          },
          methodBaseInfo: {
            id: form.MethodInfo.id,
            method_uuid: form.MethodInfo.project_uuid,
            // project_uuid:"",
            collection_mode_type: "1",
            // sample_weight:"",
            flash_column: form.MethodInfo.flashColumn,
            load_method: "",
            load_detail: "",
            samplecollection: JSON.stringify({
              collectType: form.MethodInfo.sampleCollection.collectType,
              perCollectVol: form.MethodInfo.sampleCollection.perCollectVol,
            }),
            loadAmount: form.MethodInfo.loadAmount,
            loadAmountUnit: form.MethodInfo.loadAmountUnit,
            loadAmountTotal: "",
            loadAmountTotalUnit: "",
            gradient_type: form.MethodInfo.gradientType,
            wavelength_channel_1: form.MethodInfo.wavelengthChA,
            wavelength_channel_2: form.MethodInfo.wavelengthChB,
            is_collect_channel_1:
              form.MethodInfo.wavelengthChA == null ? false : true,
            is_collect_channel_2:
              form.MethodInfo.wavelengthChB == null ? false : true,
            collection_uv_threshold: "10",
            collection_volume: "",
            full_collect_is_activation: "",
            fullCollectInfo: null,
            otherinfo: JSON.stringify({
              targetSample: form.MethodInfo.text3,
              yieldUnit:
                form.MethodInfo.yieldUnit == ""
                  ? "mg"
                  : form.MethodInfo.yieldUnit,
              separateTime: form.MethodInfo.otherInfo.separateTime,
              solventsConsume: solventConsume,
            }),
            flow_rate: "",
            method_security: "",
            method_name: form.MethodInfo.method_name,
            create_user: this.$store.state.userId,
            method_time: form.MethodInfo.method_time,
            analy_column: "",
            atomizationtemperature:
              form.MethodInfo.detectSetting == "1"
                ? form.MethodInfo.atomizationTemperature
                : "",
            detectsetting: form.MethodInfo.detectSetting,
            method_location: form.MethodInfo.method_location,
            slope_collect_info: "",
            quote_number: "",
            columndetail: JSON.stringify(form.MethodInfo.columnDetail),
            raw_con_path: "",
            extractor_user: this.$store.state.userId,
            method_type: form.MethodInfo.method_type,
            create_time: "",
            spectrum_pic: form.Chromatographic,
            evaluate_level: "",
          },
          methodHPLCInfo: {
            projectExpaSolventInfoList: phlcLists,
            methodHPLCRTInfoList: hplcLists,
          },
          methodTLCInfo: {
            projectExpaSolventInfoList: tlcLists,
            methodTLCRFInfoList: tlcRFLists,
          },
          methodFlashColumnInfo: {
            flashColumn: form.MethodInfo.flashColumn,
            cv: form.MethodInfo.columnDetail.cv,
            filler: form.MethodInfo.columnDetail.fillerLabel,
            aperture: form.MethodInfo.columnDetail.aperture,
            catalogueName: form.MethodInfo.columnDetail.catalogueName,
            spec: form.MethodInfo.columnDetail.spec,
            particleSize: form.MethodInfo.columnDetail.particleSize,
            pressure: form.MethodInfo.columnDetail.pressure,
            trailingFactorMin: form.MethodInfo.columnDetail.trailingFactorMin,
            trailingFactorMax: form.MethodInfo.columnDetail.trailingFactorMax,
            resolution: form.MethodInfo.columnDetail.resolution,
            supplierName: form.MethodInfo.columnDetail.brand,
            length: form.MethodInfo.columnDetail.length,
            innerDiameter: form.MethodInfo.columnDetail.innerDiameter,
          },
          methodEluentSolventInfo: solventinfos,
          methodGradientInfo: { methodGradientDetailList: gradInfo },
          methodOtherInfo: {
            id: form.id,
            machineInfo: JSON.stringify({
              type: form.MachineInfo.type,
              brand: form.MachineInfo.brand,
            }),
            remark: form.remark,
            evaluateset: JSON.stringify({
              text1: form.EvaluateSet.text1,
              text2: form.EvaluateSet.text2,
            }),
            author: JSON.stringify({
              username: this.$store.state.userId,
              organization: this.$store.state.org,
              email: this.$store.state.email,
            }),
            purityresconfirmation: JSON.stringify({
              tlc: {
                solvents: pSolvents,
                tlcLabel:
                  form.purityResConfirmation.tlc.label != undefined
                    ? form.purityResConfirmation.tlc.label
                    : "",
                tlcPic: form.purityResConfirmation.tlc.tlcPic,
              },
              type: form.purityResConfirmation.type,
              hplc: hplcValue,
            }),
            sampleanalysis: JSON.stringify({
              tlc: {
                solvents: saSolvents,
                tlcLabel: form.sampleAnalysis.tlc.tlcLabel,
                tlcPic: form.sampleAnalysis.tlc.tlcPic,
              },
              hplc: hplcSValue,
              type: form.sampleAnalysis.type,
            }),
          },
        };
        // console.log('updateSepaMethod',form,data)
        this.$api.post(
          "/datacenter/updateSepaMethod",
          {
            methodDetailInfo: data,
            methodId: this.$store.state.sepaMethods.editId,
            state: this.$store.state.sepaMethods.stateValue,
          },
          (res) => {
            try {
              // debugger
              if (res.data.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.$store.state.sepaMethods.edit = false;
                // this.$refs.InputOriginSampleInfoRef.resetForm();
                // this.$refs.InputOriginMethodsRef.resetForm();
                // this.$refs.InputMethodInfoRef.resetForm();
                // this.$refs.InputResConditionRef.resetForm();
                // this.$refs.InPutCompreEvalutionRef.resetForm();
                // this.$refs.InputMachineInfoRef.resetForm();
                this.$store.commit("updateTabs", {
                  tag: "add",
                  tab: {
                    name: "9-2",
                    title: "查看分离方法",
                  },
                });
                this.$store.commit("updateTabs", {
                  tag: "remove",
                  targetName: "9-1",
                });
              } else {
                // debugger;
                this.$message.error(`修改失败， 原因为: ${this.data.data}`);
              }
            } catch (e) {
              // debugger;
              this.$message.error(`修改失败， 原因为: ${e.message}`);
            }
          }
        );
      } else {
        let data = {
          methodCreateUserInfo: {
            username: this.$store.state.userId,
            organization: this.$store.state.org,
            email: this.$store.state.email,
          },
          methodMainInfo: {
            sepa_method_type: form.MethodInfo.method_type,
            spectrum_pic: form.Chromatographic,
            method_time: form.MethodInfo.method_time,
          },
          methodSampleInfo: {
            target_sample_list: [
              {
                sample_cas_info: form.SampleInfo.CAS,
                sample_name: form.SampleInfo.TargetName,
                sample_smiles: form.SampleInfo.TargetSmiles,
                sample_pic: form.SampleInfo.TargetPic,
                sample_type: 1,
              },
            ],
            reactant_sample_list: startobject,
          },
          methodBaseInfo: {
            id: form.MethodInfo.id,
            // method_uuid:"",
            // project_uuid:"",
            collection_mode_type: "1",
            // sample_weight:"",
            flash_column: form.MethodInfo.flashColumn,
            load_method: "",
            load_detail: "",
            samplecollection: JSON.stringify({
              collectType: form.MethodInfo.sampleCollection.collectType,
              perCollectVol: form.MethodInfo.sampleCollection.perCollectVol,
            }),
            loadAmount: form.MethodInfo.loadAmount,
            loadAmountUnit: form.MethodInfo.loadAmountUnit,
            loadAmountTotal: "",
            loadAmountTotalUnit: "",
            gradient_type: form.MethodInfo.gradientType,
            wavelength_channel_1: form.MethodInfo.wavelengthChA,
            wavelength_channel_2: form.MethodInfo.wavelengthChB,
            is_collect_channel_1:
              form.MethodInfo.wavelengthChA == null ? false : true,
            is_collect_channel_2:
              form.MethodInfo.wavelengthChB == null ? false : true,
            collection_uv_threshold: "10",
            collection_volume: "",
            full_collect_is_activation: "",
            fullCollectInfo: null,
            otherinfo: JSON.stringify({
              targetSample: form.MethodInfo.text3,
              yieldUnit:
                form.MethodInfo.yieldUnit == ""
                  ? "mg"
                  : form.MethodInfo.yieldUnit,
              separateTime: form.MethodInfo.otherInfo.separateTime,
              solventsConsume: solventConsume,
            }),
            flow_rate: "",
            method_security: "",
            method_name: form.MethodInfo.method_name,
            create_user: this.$store.state.userId,
            method_time: form.MethodInfo.method_time,
            analy_column: "",
            atomizationtemperature:
              form.MethodInfo.detectSetting == "1"
                ? form.MethodInfo.atomizationTemperature
                : "",
            detectsetting: form.MethodInfo.detectSetting,
            method_location: form.MethodInfo.method_location,
            slope_collect_info: "",
            quote_number: "",
            columndetail: JSON.stringify(form.MethodInfo.columnDetail),
            raw_con_path: "",
            extractor_user: this.$store.state.userId,
            method_type: form.MethodInfo.method_type,
            create_time: "",
            spectrum_pic: form.Chromatographic,
            evaluate_level: "",
          },
          methodHPLCInfo: {
            projectExpaSolventInfoList: phlcLists,
            methodHPLCRTInfoList: hplcLists,
          },
          methodTLCInfo: {
            projectExpaSolventInfoList: tlcLists,
            methodTLCRFInfoList: tlcRFLists,
          },
          methodFlashColumnInfo: {
            flashColumn: form.MethodInfo.flashColumn,
            cv: form.MethodInfo.columnDetail.cv,
            filler: form.MethodInfo.columnDetail.fillerLabel,
            aperture: form.MethodInfo.columnDetail.aperture,
            catalogueName: form.MethodInfo.columnDetail.catalogueName,
            spec: form.MethodInfo.columnDetail.spec,
            particleSize: form.MethodInfo.columnDetail.particleSize,
            pressure: form.MethodInfo.columnDetail.pressure,
            trailingFactorMin: form.MethodInfo.columnDetail.trailingFactorMin,
            trailingFactorMax: form.MethodInfo.columnDetail.trailingFactorMax,
            resolution: form.MethodInfo.columnDetail.resolution,
            supplierName: form.MethodInfo.columnDetail.brand,
            length: form.MethodInfo.columnDetail.length,
            innerDiameter: form.MethodInfo.columnDetail.innerDiameter,
          },
          methodEluentSolventInfo: solventinfos,
          methodGradientInfo: { methodGradientDetailList: gradInfo },
          methodOtherInfo: {
            id: form.id,
            machineInfo: JSON.stringify({
              type: form.MachineInfo.type,
              brand: form.MachineInfo.brand,
            }),
            remark: form.remark,
            evaluateset: JSON.stringify({
              text1: form.EvaluateSet.text1,
              text2: form.EvaluateSet.text2,
            }),
            author: JSON.stringify({
              username: this.$store.state.userId,
              organization: this.$store.state.org,
              email: this.$store.state.email,
            }),
            purityresconfirmation: JSON.stringify({
              tlc: {
                solvents: pSolvents,
                tlcLabel:
                  form.purityResConfirmation.tlc.label != undefined
                    ? form.purityResConfirmation.tlc.label
                    : "",
                tlcPic: form.purityResConfirmation.tlc.tlcPic,
              },
              type: form.purityResConfirmation.type,
              hplc: hplcValue,
            }),
            sampleanalysis: JSON.stringify({
              tlc: {
                solvents: saSolvents,
                tlcLabel: form.sampleAnalysis.tlc.tlcLabel,
                tlcPic: form.sampleAnalysis.tlc.tlcPic,
              },
              hplc: hplcSValue,
              type: form.sampleAnalysis.type,
            }),
          },
        };
        this.$api.post("/datacenter/saveSepeMethod", data, (res) => {
          try {
            // debugger
            if (res.data.data.code == 200) {
              this.$message({
                type: "success",
                message: "录入成功",
              });
              // this.$refs.InputOriginSampleInfoRef.resetForm();
              // this.$refs.InputOriginMethodsRef.resetForm();
              // this.$refs.InputMethodInfoRef.resetForm();
              // this.$refs.InputResConditionRef.resetForm();
              // this.$refs.InPutCompreEvalutionRef.resetForm();
              // this.$refs.InputMachineInfoRef.resetForm();
              this.$store.commit("updateTabs", {
                tag: "add",
                tab: {
                  name: "9-2",
                  title: "查看分离方法",
                },
              });
              this.$store.commit("updateTabs", {
                tag: "remove",
                targetName: "9-1",
              });
            } else {
              // debugger;
              this.$message.error(`录入失败， 原因为: ${this.data.data}`);
            }
          } catch (e) {
            // debugger;
            this.$message.error(`录入失败， 原因为: ${e.message}`);
          }
        });
      }
    },
    cancel: function () {
      if (this.$store.state.sepaMethods.edit) {
        this.$refs.InputOriginSampleInfoRef.resetForm();
        this.$refs.InputOriginMethodsRef.resetForm();
        this.$refs.InputMethodInfoRef.resetForm();
        this.$refs.InputResConditionRef.resetForm();
        this.$refs.InPutCompreEvalutionRef.resetForm();
        this.$refs.InputMachineInfoRef.resetForm();
        this.$store.commit("updateTabs", {
          tag: "remove",
          targetName: "9-1",
        });
        this.$store.commit("updateTabs", {
          tag: "add",
          tab: {
            name: "9-2",
            title: "查看分离方法",
          },
        });
      } else {
        this.$refs.InputOriginSampleInfoRef.resetForm();
        this.$refs.InputOriginMethodsRef.resetForm();
        this.$refs.InputMethodInfoRef.resetForm();
        this.$refs.InputResConditionRef.resetForm();
        this.$refs.InPutCompreEvalutionRef.resetForm();
        this.$refs.InputMachineInfoRef.resetForm();
      }
    },
    saveSepaMethods: function () {
      for (
        let i = 0;
        i < this.$store.state.sepaMethods.GradientList.length;
        i++
      ) {
        let channel1 = [];
        for (
          let j = 0;
          j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
          j++
        ) {
          channel1.push(
            this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
          );
        }
        if (
          channel1.indexOf(
            this.$store.state.sepaMethods.GradientList[i].channel_1
          ) == -1
        ) {
          this.$store.state.sepaMethods.GradientList[i].channel_1 = "";
        }
        if (this.$store.state.sepaMethods.GradientList[i].channel_2 != "") {
          let values = [];
          for (
            let j = 0;
            j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
            j++
          ) {
            values.push(
              this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
            );
          }
          if (
            values.indexOf(
              this.$store.state.sepaMethods.GradientList[i].channel_2
            ) == -1
          ) {
            this.$store.state.sepaMethods.GradientList[i].channel_2 = "";
          }
        }
        if (this.$store.state.sepaMethods.GradientList[i].channel_3 != "") {
          let values = [];
          for (
            let j = 0;
            j < this.$store.state.sepaMethods.MethodInfo.solvents.length;
            j++
          ) {
            values.push(
              this.$store.state.sepaMethods.MethodInfo.solvents[j].channel
            );
          }
          if (
            values.indexOf(
              this.$store.state.sepaMethods.GradientList[i].channel_3
            ) == -1
          ) {
            this.$store.state.sepaMethods.GradientList[i].channel_3 = "";
          }
        }
      }
      let element = [];
      let element2 = [];
      for (
        let index = 0;
        index < this.$store.state.sepaMethods.GradientList.length;
        index++
      ) {
        element.push(
          this.$store.state.sepaMethods.GradientList[index].channel_1
        );
        element2.push(
          this.$store.state.sepaMethods.GradientList[index].channel_2
        );
      }
      console.log(
        this.$store.state.sepaMethods.sampleAnalysis.tlc.tlcColorType
      );
      if (
        this.$store.state.sepaMethods.sampleAnalysis.tlc.tlcColorType ==
        undefined
      ) {
        console.log("请选择显色方式");
      }
      if (
        this.$store.state.sepaMethods.sampleAnalysis.tlc.tlcColorType == 0 &&
        !this.$store.state.sepaMethods.sampleAnalysis.tlc.tlcColor
      ) {
        console.log("请输入显色方式");
      }
      if (this.$store.state.sepaMethods.SampleInfo.TargetPic == "") {
        this.$message.error("请上传目标化合物的结构式");
        return;
      } else if (this.$store.state.sepaMethods.MethodInfo.flashColumn == "") {
        this.$message.error("请输入色谱柱型号");
        return;
      } else if (this.$store.state.sepaMethods.MethodInfo.loadAmount == "") {
        this.$message.error("请输入上样量");
        return;
      } else if (
        this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
        this.$store.state.sepaMethods.MethodInfo.wavelengthChA == ""
      ) {
        this.$message.error("请输入检测波长1");
        return;
      } else if (
        this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
        this.$store.state.sepaMethods.MethodInfo.wavelengthChB == ""
      ) {
        this.$message.error("请输入检测波长2");
        return;
      } else if (
        this.$store.state.sepaMethods.MethodInfo.detectSetting == "1" &&
        this.$store.state.sepaMethods.MethodInfo.atomizationTemperature == ""
      ) {
        this.$message.error("请输入雾化温度");
        return;
      } else if (this.$store.state.showEluent) {
        this.$message.error("请完善溶剂信息");
        return;
      } else if (
        this.$store.state.sepaMethods.sampleAnalysis.tlc.tlcColorType ==
        undefined
      ) {
        this.$message.error("请选择显色方式");
        return;
      } else if (
        this.$store.state.sepaMethods.sampleAnalysis.tlc.tlcColorType == 0 &&
        !this.$store.state.sepaMethods.sampleAnalysis.tlc.tlcColor
      ) {
        this.$message.error("请输入显色方式");
        return;
      } else if (element.includes("")) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (element2.includes("")) {
        this.$message.error("请完善梯度信息");
        return;
      } else if (this.$store.state.sepaMethods.Chromatographic == "") {
        this.$message.error("请上传分离图谱");
        return;
      } else if (
        (this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
          this.$store.state.sepaMethods.MethodInfo.wavelengthChA == "0") ||
        (this.$store.state.sepaMethods.MethodInfo.detectSetting == "0" &&
          this.$store.state.sepaMethods.MethodInfo.wavelengthChB == "0")
      ) {
        this.$message.error("请正确输入检测波长");
        return;
      }
      this.constructInputForm();
      let form = this.form;
      let startobject = [];
      for (let i = 0; i < form.startObjects.length; i++) {
        startobject.push({
          sample_cas_info: form.startObjects[i].cas,
          sample_name: form.startObjects[i].name,
          sample_pic: form.startObjects[i].png,
          sample_type: 1,
          sample_smiles: form.startObjects[i].smile,
        });
      }
      let tlcLists = [];
      let phlcLists = [];
      let hplcLists = [
        { component_index: "", area: 0, percent: "", tFlag: "", rt_time: "" },
        { component_index: "", area: 0, percent: "", tFlag: "", rt_time: "" },
        { component_index: "", area: 0, percent: "", tFlag: "", rt_time: "" },
      ];
      if (form.sampleAnalysis.type == 0) {
        if (form.SolventList.length > 0) {
          if (form.SolventList[0].Solvent != "") {
            tlcLists.push({
              percent: form.SolventList[0].Percent,
              eluent_channel: 0,
              solvent: form.SolventList[0].Solvent,
              polarity: form.SolventList[0].Polarity,
              density: form.SolventList[0].Density,
              solvent_id: form.SolventList[0].id,
            });
            if (form.SolventList[1].Solvent != "") {
              tlcLists.push({
                percent: form.SolventList[1].Percent,
                eluent_channel: 1,
                solvent: form.SolventList[1].Solvent,
                polarity: form.SolventList[1].Polarity,
                density: form.SolventList[1].Density,
                solvent_id: form.SolventList[1].id,
              });
            }
          }
        }
      } else {
        if (form.sampleAnalysis.hplc.hplcflowA != undefined) {
          if (form.sampleAnalysis.hplc.hplcflowA.length > 0) {
            phlcLists.push({
              eluent_channel: 0,
              solvent: form.sampleAnalysis.hplc.hplcflowA[0].Solvent,
              polarity: form.sampleAnalysis.hplc.hplcflowA[0].Polarity,
              density: form.sampleAnalysis.hplc.hplcflowA[0].Density,
              solvent_id: form.sampleAnalysis.hplc.hplcflowA[0].id,
            });
          }
        }
        if (form.sampleAnalysis.hplc.hplcflowB != undefined) {
          if (form.sampleAnalysis.hplc.hplcflowB.length > 0) {
            phlcLists.push({
              eluent_channel: 1,
              solvent: form.sampleAnalysis.hplc.hplcflowB[0].Solvent,
              polarity: form.sampleAnalysis.hplc.hplcflowB[0].Polarity,
              density: form.sampleAnalysis.hplc.hplcflowB[0].Density,
              solvent_id: form.sampleAnalysis.hplc.hplcflowB[0].id,
            });
          }
        }

        if (
          form.RTList[0].Time != "" ||
          form.RTList[1].Time != "" ||
          form.RTList[2].Time != ""
        ) {
          hplcLists = [];
          for (let i = 0; i < form.RTList.length; i++) {
            hplcLists.push({
              component_index: form.RTList[i].ComponentIndex,
              area: 0,
              percent: form.RTList[i].Percent,
              tFlag: form.RTList[i].TFlag,
              rt_time: form.RTList[i].Time,
            });
          }
        }
      }

      let saSolvents = [];
      if (form.sampleAnalysis.type == 0) {
        if (form.SolventList.length > 0) {
          if (
            form.SolventList[0].Solvent != "" ||
            form.SolventList[1].Solvent != ""
          ) {
            saSolvents = form.SolventList;
          }
        }
      }

      let tlcRFLists = [];
      if (
        form.RFList[0].Value != "" ||
        form.RFList[1].Value != "" ||
        form.RFList[2].Value != ""
      ) {
        for (let i = 0; i < form.RFList.length; i++) {
          tlcRFLists.push({
            value: form.RFList[i].Value,
            rfflag: parseInt(form.RFList[i].RFFlag),
          });
        }
      }
      let solventinfos = {
        eluent_solvent_channel_A: {},
        eluent_solvent_channel_B: {},
        eluent_solvent_channel_C: {},
        eluent_solvent_channel_D: {},
      };
      for (let i = 0; i < form.MethodInfo.solvents.length; i++) {
        if (form.MethodInfo.solvents[i].channel == "A") {
          solventinfos.eluent_solvent_channel_A = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
        if (form.MethodInfo.solvents[i].channel == "B") {
          solventinfos.eluent_solvent_channel_B = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
        if (form.MethodInfo.solvents[i].channel == "C") {
          solventinfos.eluent_solvent_channel_C = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
        if (form.MethodInfo.solvents[i].channel == "D") {
          solventinfos.eluent_solvent_channel_D = {
            channel: form.MethodInfo.solvents[i].channel,
            solvent: form.MethodInfo.solvents[i].nameCh,
            polarity: form.MethodInfo.solvents[i].polarity,
            solvent_id: form.MethodInfo.solvents[i].id,
            density: form.MethodInfo.solvents[i].density,
          };
        }
      }
      let gradInfo = [];
      for (let i = 0; i < form.GradientList.length; i++) {
        gradInfo.push({
          begin_cv: form.GradientList[i].begin_cv,
          end_cv: Number(form.GradientList[i].end_cv).toFixed(1).toString(),
          flow_rate: form.GradientList[i].flow_rate,
          begin_time: form.GradientList[i].begin_time,
          end_time: Number(form.GradientList[i].end_time).toFixed(1).toString(),
          channel_1: form.GradientList[i].channel_1,
          channel_2: form.GradientList[i].channel_2,
          channel_3: form.GradientList[i].channel_3,
          percent_3: form.GradientList[i].percent_3,
          begin_percent_2: form.GradientList[i].begin_percent_2,
          end_percent_2: form.GradientList[i].end_percent_2,
        });
      }
      let hplcValue = {};
      let purList = [];
      if (form.purityResConfirmation.hplc.hplcflowA != undefined) {
        if (form.purityResConfirmation.hplc.hplcflowA.length > 0) {
          purList.push({
            eluent_channel: 0,
            solvent: form.purityResConfirmation.hplc.hplcflowA[0].Solvent,
            polarity: form.purityResConfirmation.hplc.hplcflowA[0].Polarity,
            density: form.purityResConfirmation.hplc.hplcflowA[0].Density,
            solvent_id: form.purityResConfirmation.hplc.hplcflowA[0].id,
          });
        }
      }
      if (form.purityResConfirmation.hplc.hplcflowB != undefined) {
        if (form.purityResConfirmation.hplc.hplcflowB.length > 0) {
          purList.push({
            eluent_channel: 1,
            solvent: form.purityResConfirmation.hplc.hplcflowB[0].Solvent,
            polarity: form.purityResConfirmation.hplc.hplcflowB[0].Polarity,
            density: form.purityResConfirmation.hplc.hplcflowB[0].Density,
            solvent_id: form.purityResConfirmation.hplc.hplcflowB[0].id,
          });
        }
      }
      if (form.purityResConfirmation.hplc.flashColumn != undefined) {
        hplcValue = {
          analysisColumn: {
            flowPhase: form.purityResConfirmation.hplc.flashColumn.flow_rate,
            analysisName:
              form.purityResConfirmation.hplc.flashColumn.analysis_column,
            particleSize:
              form.purityResConfirmation.hplc.flashColumn.particle_diameter,
            innerDiameter:
              form.purityResConfirmation.hplc.flashColumn.inner_diameter,
            length: form.purityResConfirmation.hplc.flashColumn.length,
          },
          hplcPic: form.purityResConfirmation.hplc.hplcPic,
          solvents: purList,
        };
      }
      let hplcSValue = {};
      if (form.sampleAnalysis.type == 1) {
        if (form.sampleAnalysis.hplc != undefined) {
          hplcSValue = {
            analysisColumn: {
              flowPhase: form.sampleAnalysis.hplc.flashColumn.flow_rate,
              analysisName:
                form.sampleAnalysis.hplc.flashColumn.analysis_column,
              particleSize:
                form.sampleAnalysis.hplc.flashColumn.particle_diameter,
              innerDiameter:
                form.sampleAnalysis.hplc.flashColumn.inner_diameter,
              length: form.sampleAnalysis.hplc.flashColumn.length,
            },
            hplcPic: form.sampleAnalysis.hplc.hplcPic,
            solvents: phlcLists,
          };
        }
      }

      let solventConsume = [];
      if (form.MethodInfo.otherInfo.solventsConsume.length > 0) {
        if (form.MethodInfo.otherInfo.solventsConsume[0].solvents != "") {
          for (
            let i = 0;
            i < form.MethodInfo.otherInfo.solventsConsume.length;
            i++
          ) {
            solventConsume.push({
              solvents: form.MethodInfo.otherInfo.solventsConsume[i].solvents,
              vol: form.MethodInfo.otherInfo.solventsConsume[i].vol,
            });
          }
        }
      }
      let pSolvents = [];
      if (form.purityResConfirmation.type == 0) {
        if (form.purityResConfirmation.tlc.solvents.length > 0) {
          if (
            form.purityResConfirmation.tlc.solvents[0].Solvent != "" ||
            form.purityResConfirmation.tlc.solvents[1].Solvent != ""
          ) {
            pSolvents = form.purityResConfirmation.tlc.solvents;
          }
        }
      }
      console.log(form);
      if (this.$store.state.sepaMethods.edit) {
        let data = {
          methodCreateUserInfo: {
            username: this.$store.state.userId,
            organization: this.$store.state.org,
            email: this.$store.state.email,
          },
          methodMainInfo: {
            sepa_method_type: form.MethodInfo.method_type,
            spectrum_pic: form.Chromatographic,
            method_time: form.MethodInfo.method_time,
          },
          methodSampleInfo: {
            target_sample_list: [
              {
                sample_cas_info: form.SampleInfo.CAS,
                sample_name: form.SampleInfo.TargetName,
                sample_smiles: form.SampleInfo.TargetSmiles,
                sample_pic: form.SampleInfo.TargetPic,
                sample_type: 1,
              },
            ],
            reactant_sample_list: startobject,
          },
          methodBaseInfo: {
            id: form.MethodInfo.id,
            method_uuid: form.MethodInfo.project_uuid,
            samplePeakAppearance: form.MethodInfo.samplePeakAppearance
              ? form.MethodInfo.samplePeakAppearance
              : "",
            // project_uuid:"",
            collection_mode_type: "1",
            // sample_weight:"",
            flash_column: form.MethodInfo.flashColumn,
            load_method: "",
            load_detail: "",
            samplecollection: JSON.stringify({
              collectType: form.MethodInfo.sampleCollection.collectType,
              perCollectVol: form.MethodInfo.sampleCollection.perCollectVol,
            }),
            loadAmount: form.MethodInfo.loadAmount,
            loadAmountUnit: form.MethodInfo.loadAmountUnit,
            loadAmountTotal: "",
            loadAmountTotalUnit: "",
            gradient_type: form.MethodInfo.gradientType,
            wavelength_channel_1: form.MethodInfo.wavelengthChA,
            wavelength_channel_2: form.MethodInfo.wavelengthChB,
            is_collect_channel_1:
              form.MethodInfo.wavelengthChA == null ? false : true,
            is_collect_channel_2:
              form.MethodInfo.wavelengthChB == null ? false : true,
            collection_uv_threshold: "10",
            collection_volume: "",
            full_collect_is_activation: "",
            fullCollectInfo: null,
            otherinfo: JSON.stringify({
              targetSample: form.MethodInfo.text3,
              yieldUnit:
                form.MethodInfo.yieldUnit == ""
                  ? "mg"
                  : form.MethodInfo.yieldUnit,
              separateTime: form.MethodInfo.otherInfo.separateTime,
              solventsConsume: solventConsume,
            }),
            flow_rate: "",
            method_security: "",
            method_name: form.MethodInfo.method_name,
            create_user: this.$store.state.userId,
            method_time: form.MethodInfo.method_time,
            analy_column: "",
            atomizationtemperature:
              form.MethodInfo.detectSetting == "1"
                ? form.MethodInfo.atomizationTemperature
                : "",
            detectsetting: form.MethodInfo.detectSetting,
            method_location: form.MethodInfo.method_location,
            slope_collect_info: "",
            quote_number: "",
            columndetail: JSON.stringify(form.MethodInfo.columnDetail),
            raw_con_path: "",
            extractor_user: this.$store.state.userId,
            method_type: form.MethodInfo.method_type,
            create_time: "",
            spectrum_pic: form.Chromatographic,
            evaluate_level: "",
          },
          methodHPLCInfo: {
            projectExpaSolventInfoList: phlcLists,
            methodHPLCRTInfoList: hplcLists,
          },
          methodTLCInfo: {
            projectExpaSolventInfoList: tlcLists,
            methodTLCRFInfoList: tlcRFLists,
          },
          methodFlashColumnInfo: {
            flashColumn: form.MethodInfo.flashColumn,
            cv: form.MethodInfo.columnDetail.cv,
            filler: form.MethodInfo.columnDetail.fillerLabel,
            aperture: form.MethodInfo.columnDetail.aperture,
            catalogueName: form.MethodInfo.columnDetail.catalogueName,
            spec: form.MethodInfo.columnDetail.spec,
            particleSize: form.MethodInfo.columnDetail.particleSize,
            pressure: form.MethodInfo.columnDetail.pressure,
            trailingFactorMin: form.MethodInfo.columnDetail.trailingFactorMin,
            trailingFactorMax: form.MethodInfo.columnDetail.trailingFactorMax,
            resolution: form.MethodInfo.columnDetail.resolution,
            supplierName: form.MethodInfo.columnDetail.brand,
            length: form.MethodInfo.columnDetail.length,
            innerDiameter: form.MethodInfo.columnDetail.innerDiameter,
          },
          methodEluentSolventInfo: solventinfos,
          methodGradientInfo: { methodGradientDetailList: gradInfo },
          methodOtherInfo: {
            id: form.id,
            machineInfo: JSON.stringify({
              type: form.MachineInfo.type,
              brand: form.MachineInfo.brand,
            }),
            remark: form.remark,
            evaluateset: JSON.stringify({
              text1: form.EvaluateSet.text1,
              text2: form.EvaluateSet.text2,
            }),
            author: JSON.stringify({
              username: this.$store.state.userId,
              organization: this.$store.state.org,
              email: this.$store.state.email,
            }),
            purityresconfirmation: JSON.stringify({
              tlc: {
                solvents: pSolvents,
                tlcLabel:
                  form.purityResConfirmation.tlc.label != undefined
                    ? form.purityResConfirmation.tlc.label
                    : "",
                tlcPic: form.purityResConfirmation.tlc.tlcPic,
                remark: form.purityResConfirmation.tlc.remark
                  ? form.purityResConfirmation.tlc.remark
                  : "",
              },
              type: form.purityResConfirmation.type,
              hplc: hplcValue,
            }),
            sampleanalysis: JSON.stringify({
              tlc: {
                solvents: saSolvents,
                tlcLabel: form.sampleAnalysis.tlc.tlcLabel,
                tlcPic: form.sampleAnalysis.tlc.tlcPic,
              },
              hplc: hplcSValue,
              type: form.sampleAnalysis.type,
              tlcColorType: form.sampleAnalysis.tlc.tlcColorType,
              tlcColor:
                form.sampleAnalysis.tlc.tlcColorType == 0
                  ? form.sampleAnalysis.tlc.tlcColor
                  : "",
              remark: form.sampleAnalysis.tlc.remark
                ? form.sampleAnalysis.tlc.remark
                : "",
            }),
          },
        };
        console.log("updateSepaMethod1");
        this.$api.post(
          "/datacenter/updateSepaMethod",
          {
            methodDetailInfo: data,
            methodId: this.$store.state.sepaMethods.editId,
            state: this.$store.state.sepaMethods.stateValue,
          },
          (res) => {
            try {
              // debugger
              if (res.data.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.$store.state.sepaMethods.edit = false;
                //     this.$refs.InputOriginSampleInfoRef.resetForm();
                // this.$refs.InputOriginMethodsRef.resetForm();
                // this.$refs.InputMethodInfoRef.resetForm();
                // this.$refs.InputResConditionRef.resetForm();
                // this.$refs.InPutCompreEvalutionRef.resetForm();
                // this.$refs.InputMachineInfoRef.resetForm();
                this.$store.commit("updateTabs", {
                  tag: "add",
                  tab: {
                    name: "9-2",
                    title: "查看分离方法",
                  },
                });
                this.$store.commit("updateTabs", {
                  tag: "remove",
                  targetName: "9-1",
                });
              } else {
                // debugger;
                this.$message.error(`修改失败， 原因为: ${this.data.data}`);
              }
            } catch (e) {
              // debugger;
              this.$message.error(`修改失败， 原因为: ${e.message}`);
            }
          }
        );
      } else {
        let data = {
          methodCreateUserInfo: {
            username: this.$store.state.userId,
            organization: this.$store.state.org,
            email: this.$store.state.email,
          },
          methodMainInfo: {
            sepa_method_type: form.MethodInfo.method_type,
            spectrum_pic: form.Chromatographic,
            method_time: form.MethodInfo.method_time,
          },
          methodSampleInfo: {
            target_sample_list: [
              {
                sample_cas_info: form.SampleInfo.CAS,
                sample_name: form.SampleInfo.TargetName,
                sample_smiles: form.SampleInfo.TargetSmiles,
                sample_pic: form.SampleInfo.TargetPic,
                sample_type: 1,
              },
            ],
            reactant_sample_list: startobject,
          },
          methodBaseInfo: {
            id: form.MethodInfo.id,
            samplePeakAppearance: form.MethodInfo.samplePeakAppearance
              ? form.MethodInfo.samplePeakAppearance
              : "",
            // method_uuid:"",
            // project_uuid:"",
            collection_mode_type: "1",
            // sample_weight:"",
            flash_column: form.MethodInfo.flashColumn,
            load_method: "",
            load_detail: "",
            samplecollection: JSON.stringify({
              collectType: form.MethodInfo.sampleCollection.collectType,
              perCollectVol: form.MethodInfo.sampleCollection.perCollectVol,
            }),
            loadAmount: form.MethodInfo.loadAmount,
            loadAmountUnit: form.MethodInfo.loadAmountUnit,
            loadAmountTotal: "",
            loadAmountTotalUnit: "",
            gradient_type: form.MethodInfo.gradientType,
            wavelength_channel_1: form.MethodInfo.wavelengthChA,
            wavelength_channel_2: form.MethodInfo.wavelengthChB,
            is_collect_channel_1:
              form.MethodInfo.wavelengthChA == null ? false : true,
            is_collect_channel_2:
              form.MethodInfo.wavelengthChB == null ? false : true,
            collection_uv_threshold: "10",
            collection_volume: "",
            full_collect_is_activation: "",
            fullCollectInfo: null,
            otherinfo: JSON.stringify({
              targetSample: form.MethodInfo.text3,
              yieldUnit:
                form.MethodInfo.yieldUnit == ""
                  ? "mg"
                  : form.MethodInfo.yieldUnit,
              separateTime: form.MethodInfo.otherInfo.separateTime,
              solventsConsume: solventConsume,
            }),
            flow_rate: "",
            method_security: "",
            method_name: form.MethodInfo.method_name,
            create_user: this.$store.state.userId,
            method_time: form.MethodInfo.method_time,
            analy_column: "",
            atomizationtemperature:
              form.MethodInfo.detectSetting == "1"
                ? form.MethodInfo.atomizationTemperature
                : "",
            detectsetting: form.MethodInfo.detectSetting,
            method_location: form.MethodInfo.method_location,
            slope_collect_info: "",
            quote_number: "",
            columndetail: JSON.stringify(form.MethodInfo.columnDetail),
            raw_con_path: "",
            extractor_user: this.$store.state.userId,
            method_type: form.MethodInfo.method_type,
            create_time: "",
            spectrum_pic: form.Chromatographic,
            evaluate_level: "",
          },
          methodHPLCInfo: {
            projectExpaSolventInfoList: phlcLists,
            methodHPLCRTInfoList: hplcLists,
          },
          methodTLCInfo: {
            projectExpaSolventInfoList: tlcLists,
            methodTLCRFInfoList: tlcRFLists,
          },
          methodFlashColumnInfo: {
            flashColumn: form.MethodInfo.flashColumn,
            cv: form.MethodInfo.columnDetail.cv,
            filler: form.MethodInfo.columnDetail.fillerLabel,
            aperture: form.MethodInfo.columnDetail.aperture,
            catalogueName: form.MethodInfo.columnDetail.catalogueName,
            spec: form.MethodInfo.columnDetail.spec,
            particleSize: form.MethodInfo.columnDetail.particleSize,
            pressure: form.MethodInfo.columnDetail.pressure,
            trailingFactorMin: form.MethodInfo.columnDetail.trailingFactorMin,
            trailingFactorMax: form.MethodInfo.columnDetail.trailingFactorMax,
            resolution: form.MethodInfo.columnDetail.resolution,
            supplierName: form.MethodInfo.columnDetail.brand,
            length: form.MethodInfo.columnDetail.length,
            innerDiameter: form.MethodInfo.columnDetail.innerDiameter,
          },
          methodEluentSolventInfo: solventinfos,
          methodGradientInfo: { methodGradientDetailList: gradInfo },
          methodOtherInfo: {
            id: form.id,
            machineInfo: JSON.stringify({
              type: form.MachineInfo.type,
              brand: form.MachineInfo.brand,
            }),
            remark: form.remark,
            evaluateset: JSON.stringify({
              text1: form.EvaluateSet.text1,
              text2: form.EvaluateSet.text2,
            }),
            author: JSON.stringify({
              username: this.$store.state.userId,
              organization: this.$store.state.org,
              email: this.$store.state.email,
            }),
            purityresconfirmation: JSON.stringify({
              tlc: {
                solvents: pSolvents,
                tlcLabel:
                  form.purityResConfirmation.tlc.label != undefined
                    ? form.purityResConfirmation.tlc.label
                    : "",
                tlcPic: form.purityResConfirmation.tlc.tlcPic,
                remark: form.purityResConfirmation.tlc.remark,
              },
              type: form.purityResConfirmation.type.toString(),
              hplc: hplcValue,
            }),
            sampleanalysis: JSON.stringify({
              tlc: {
                solvents: saSolvents,
                tlcLabel: form.sampleAnalysis.tlc.tlcLabel,
                tlcPic: form.sampleAnalysis.tlc.tlcPic,
              },
              hplc: hplcSValue,
              type: form.sampleAnalysis.type.toString(),
              tlcColorType: form.sampleAnalysis.tlc.tlcColorType,
              tlcColor:
                form.sampleAnalysis.tlc.tlcColorType == 0
                  ? form.sampleAnalysis.tlc.tlcColor
                  : "",
              remark: form.sampleAnalysis.tlc.remark
                ? form.sampleAnalysis.tlc.remark
                : "",
            }),
          },
        };
        console.log(
          "save1",
          form,
          JSON.parse(data.methodOtherInfo.sampleanalysis)
        );
        this.$api.post("/datacenter/saveSepeMethod", data, (res) => {
          try {
            // debugger
            if (res.data.data.code == 200) {
              this.$message({
                type: "success",
                message: "录入成功",
              });
              this.$store.commit("updateTabs", {
                tag: "add",
                tab: {
                  name: "9-2",
                  title: "查看分离方法",
                },
              });
              this.$store.commit("updateTabs", {
                tag: "remove",
                targetName: "9-1",
              });
            } else {
              // debugger;
              this.$message.error(`录入失败， 原因为: ${this.data.data}`);
            }
          } catch (e) {
            // debugger;
            this.$message.error(`录入失败， 原因为: ${e.message}`);
          }
        });
      }
    },
  },
  created() {
    this.form.baseInfo = this.$store.state.sepaMethods.baseInfo;
    this.constructInputForm();
  },
};
</script>

<style scoped>
@import "../../assets/position-adjust.css";
@import "../../assets/border-style.css";
@import "../../assets/view-style.css";
.titleStyle {
  font-size: 17px;
  font-weight: 600;
  box-sizing: border-box;
  border-left: 6px solid #58aaff;
  padding: 0 0 0 10px;
  margin: 24px 0 5px 0;
}
</style>
